import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'
import type { AccessTokenData, AuthorizationResource } from '@empathyco/playboard-core-domain'
import type { Store } from 'vuex'
import { PermissionLevelEnum } from '@empathybroker/tsclient-play/dist/enums/permission-level.enum'
import { CONTAINER } from '../config/inversify.config'
import { TYPES } from '../config/inversify.types'
import { AUTH_CONSTS } from '../store/auth/auth.consts'
import { CONFIG_CONSTS } from '../store/config/config.consts'

export class UserUtils {
  private static store() {
    return CONTAINER.get<Store<any>>(TYPES.Store)
  }
  private static getTokenInfo(): AccessTokenData {
    return this.store().getters[`${AUTH_CONSTS.moduleName}/${AUTH_CONSTS.getters.tokenInfo}`]
  }

  private static getInstance(): Instance {
    return this.store().getters[
      `${CONFIG_CONSTS.moduleName}/${CONFIG_CONSTS.getters.currentInstance}`
    ]
  }

  private static getPermission(tool: string): AuthorizationResource | undefined {
    const permissions = this.getTokenInfo().authorization.resources
    return permissions.find(permission => permission.name.toLowerCase() === tool.toLowerCase())
  }

  static hasPermission(
    tool: string,
    level: PermissionLevelEnum | string = PermissionLevelEnum.WRITE,
    options?: {
      instanceId?: string
      permissionName?: string
    },
  ): boolean {
    const { instanceId, permissionName } = {
      instanceId: this.getInstance()?.id,
      permissionName: 'access-level',
      ...options,
    }

    const permission = this.getPermission(tool)

    if (!permission) {
      return false
    }

    const instancePermissions = permission.conditions.filter(
      condition => condition.instance.includes(instanceId) || condition.instance.includes('*'),
    )

    const hasRequiredPermissionLevel = instancePermissions.some(permission =>
      permission[permissionName]?.map(value => value.toLowerCase()).includes(level.toLowerCase()),
    )

    return hasRequiredPermissionLevel
  }
}
